export const label = 'font-medium block text-base font-body text-textMid';
export const wrapper = 'bg-white h-full pt-2 pb-4 px-4';
